<template>
    <div class="rule-container">
        <div class="rule-header">
            <h1>熊猫点钢平台交易规则</h1>
            <p class="version">版本号：V2.0</p>
            <p class="date">生效日期：2026年2月1日</p>
            <p class="date">更新日期：2026年2月1日</p>
        </div>

        <!-- 重要提示 -->
        <div class="section">
            <h2 class="section-title important">重要提示</h2>
            <p class="text">
                请您在使用熊猫点钢平台交易服务前，仔细阅读本规则的全部内容。如您不同意本规则的任何条款，请立即停止使用平台交易服务。您的点价、下单或使用行为即视为您已阅读并同意本规则的约束。
            </p>
        </div>

        <!-- 特别提示 -->
        <div class="section">
            <h2 class="section-title">特别提示：</h2>
            <ul class="list">
                <li>点价交易存在市场风险，请您谨慎决策</li>
                <li>交易双方应自行承担交易风险</li>
                <li>平台仅提供信息撮合服务，不参与实际交易</li>
                <li>请您妥善保管账号密码，对账号下的所有行为负责</li>
            </ul>
        </div>

        <!-- 第一条 总则 -->
        <div class="section">
            <h2 class="section-title">第一条 总则</h2>
            <div class="clause">
                <h3>1.1 规则主体</h3>
                <p class="text">
                    本规则是您与熊猫点钢平台（含网站、APP、小程序等，以下简称"平台"）所有者点价宝科技（四川）有限公司（以下简称"我们"或"公司"）之间就钢材等产品的点价交易及相关服务所订立的契约。
                </p>
            </div>

            <div class="clause">
                <h3>1.2 规则范围</h3>
                <p class="text">本规则适用于平台提供的钢材等产品点价交易服务，包括但不限于：</p>
                <ul class="list">
                    <li>资源发布与浏览</li>
                    <li>点价交易</li>
                    <li>订单管理</li>
                    <li>交易结算</li>
                    <li>售后服务</li>
                </ul>
            </div>

            <div class="clause">
                <h3>1.3 平台服务时间</h3>
                <h4>1.3.1 平台开放时间</h4>
                <p class="text">
                    除平台公告说明外，平台每天24小时对外开放，用户可以在任意时间登录平台查询资源、查询订单状态等操作。
                </p>

                <h4>1.3.2 点价功能开放时间</h4>
                <p class="text">
                    点价功能仅在营业时间内开放。平台默认营业时间为：周一至周五（法定节假日除外），具体时间段分为：
                </p>
                <ul class="list">
                    <li>21:00 - 23:00</li>
                    <li>09:00 - 10:15</li>
                    <li>10:30 - 11:30</li>
                    <li>13:30 - 15:00</li>
                </ul>

                <h4>1.3.3 期货交易时段限制</h4>
                <p class="text">
                    平台用户求购或出售的资源仅在上海期货交易所螺纹钢期货、热卷期货交易时段内可被点价；其他时段，资源仅供浏览，不可以被点价。
                </p>

                <h4>1.3.4 特殊情况处理</h4>
                <p class="text">
                    因不可抗力或其它因素影响点价正常进行时，平台有权做出推迟点价时间、提前结束点价、暂停点价等决定。一般情况下将提前公告，如因紧急事件导致无法提前公告或无法公告的，平台可视情况选择不予公告。
                </p>

                <h4>1.3.5 其他规定</h4>
                <p class="text">其他关于点价时间的特殊规定，以平台公告为准。</p>
            </div>

            <div class="clause">
                <h3>1.4 规则变更</h3>
                <p class="text">
                    我们有权在必要时修改本规则条款，修改后的规则将在平台公布。我们将在规则变更前通过平台公告、站内信、短信等方式通知您。如您在规则变更后继续使用平台服务，即视为您已接受修改后的规则。
                </p>
            </div>
        </div>

        <!-- 第二条 用户权利与义务 -->
        <div class="section">
            <h2 class="section-title">第二条 用户权利与义务</h2>
            <div class="clause">
                <h3>2.1 用户权利</h3>
                <ul class="list">
                    <li>2.1.1 您有权按照本规则约定使用平台交易服务。</li>
                    <li>2.1.2 您有权发布、修改、下架自己的资源信息。</li>
                    <li>2.1.3 您有权浏览其他用户发布的资源信息。</li>
                    <li>2.1.4 您有权对其他用户的资源进行点价交易。</li>
                    <li>2.1.5 您有权查看自己的订单记录和交易历史。</li>
                    <li>2.1.6 您有权对交易纠纷提出申诉。</li>
                </ul>
            </div>

            <div class="clause">
                <h3>2.2 用户义务</h3>
                <ul class="list">
                    <li>2.2.1 您应确保发布的商品信息真实、准确、完整。</li>
                    <li>2.2.2 您应保证所售商品质量符合国家标准和合同约定。</li>
                    <li>2.2.3 您应按时履行订单义务，包括但不限于交付货物、支付货款等。</li>
                    <li>2.2.4 您应按时支付平台服务费用。</li>
                </ul>
                <p class="text">2.2.5 您不得从事以下行为：</p>
                <ul class="list sub-list">
                    <li>（1）发布虚假或误导性商品信息；</li>
                    <li>（2）恶意点价或恶意取消订单；</li>
                    <li>（3）欺诈、胁迫其他用户；</li>
                    <li>（4）侵犯其他用户或第三方的合法权益；</li>
                    <li>（5）利用平台从事违法违规活动；</li>
                    <li>（6）其他违反法律法规或本规则的行为。</li>
                </ul>
            </div>
        </div>

        <!-- 第三条 资源管理 -->
        <div class="section">
            <h2 class="section-title">第三条 资源管理</h2>
            <div class="clause">
                <h3>3.1 资源定义</h3>
                <p class="text">
                    资源是指用户拥有在平台上架待点价的商品，包括但不限于螺纹钢、热卷等钢材产品。
                </p>
            </div>

            <div class="clause">
                <h3>3.2 资源发布</h3>
                <h4>3.2.1 发布要求</h4>
                <p class="text">用户须按照平台规则进行资源发布，包括但不限于填写以下信息：</p>
                <ul class="list">
                    <li>品名、材质、规格</li>
                    <li>数量、重量</li>
                    <li>所在仓库、钢厂</li>
                    <li>基差（升贴水）</li>
                    <li>有效期</li>
                    <li>其他必要信息</li>
                </ul>

                <h4>3.2.2 信息真实性</h4>
                <p class="text">
                    用户应确保发布的商品及商品描述真实有效，并能提供商品对应的质保书（产品合格证）。用户应保证产品描述不存在任何虚假或不正当竞争等行为。
                </p>

                <h4>3.2.3 违规处理</h4>
                <p class="text">如因虚假信息产生纠纷，平台有权追究用户责任，包括但不限于：</p>
                <ul class="list">
                    <li>资源下架</li>
                    <li>限制发布权限</li>
                    <li>封锁账号</li>
                    <li>追究法律责任</li>
                </ul>
            </div>

            <div class="clause">
                <h3>3.3 资源管理</h3>
                <ul class="list">
                    <li>3.3.1 用户可随时修改、下架自己发布的资源。</li>
                    <li>3.3.2 资源被点价成交后，剩余数量自动更新。</li>
                    <li>3.3.3 资源有效期届满后自动下架。</li>
                    <li>3.3.4 平台有权对违规资源进行下架处理。</li>
                </ul>
            </div>
        </div>

        <!-- 第四条 点价交易 -->
        <div class="section">
            <h2 class="section-title">第四条 点价交易</h2>
            <div class="clause">
                <h3>4.1 定价方式</h3>
                <p class="text">
                    平台采用点价的定价方式，即以上海期货交易所螺纹钢期货/热卷期货的主力合约价格作为相关商品的基准价，在基准价基础上加基差（升贴水）及相关费用来确定用户与交易对手方的现货交割价。
                </p>
                <p class="formula">
                    定价公式：
                    <br />
                    现货交割价 = 期货价格 + 基差 + 相关费用
                </p>
            </div>

            <div class="clause">
                <h3>4.2 主力合约</h3>
                <ul class="list">
                    <li>4.2.1 平台以上海期货交易所螺纹钢期货/热卷期货的主力合约作为基准价。</li>
                    <li>4.2.2 平台提前5个工作日公告变更螺纹钢、热卷期货主力合约作为最新基准价。</li>
                </ul>
            </div>

            <div class="clause">
                <h3>4.3 基差公布</h3>
                <p class="text">
                    平台和用户在工作日16:00-20:00公布下一个交易日的基差，用户下单时勾选《点价规则》时即表示认可。
                </p>
            </div>

            <div class="clause">
                <h3>4.4 点价流程</h3>
                <h4>4.4.1 点价发起</h4>
                <p class="text">
                    在螺纹钢期货/热卷期货交易时段内，买方可向卖方点价，或卖方可向买方点价。
                </p>

                <h4>4.4.2 价格确认</h4>
                <p class="text">
                    买方/卖方自主选择具体时点的期货价格是否为卖方/买方所接受，以平台反馈给买方/卖方的成交结果为准。平台不保证也不承诺买方/卖方指定的任何价格都会被接受。
                </p>

                <h4>4.4.3 成交锁定</h4>
                <p class="text">一旦价格被对手方接受，订单即生效，双方均不得撤回。</p>
            </div>

            <div class="clause">
                <h3>4.5 订单确认</h3>
                <h4>4.5.1 信息确认</h4>
                <p class="text">
                    用户向对手方点价提交订单时，须仔细确认所点价货物的品名、价格、数量、材质、规格、所在仓库、钢厂等信息。
                </p>

                <h4>4.5.2 信息错误责任</h4>
                <p class="text">
                    若用户提供的信息错误导致点价过程中出现利益损失的，则自行承担任何责任。
                </p>

                <h4>4.5.3 成交规则</h4>
                <p class="text">
                    同一批资源可能被多个对手方下单，但价优者先成交，可能存在点价成交数量少于下单数量的情况。该批资源成交后即被锁定，其他用户无法向该订单内的资源点价。
                </p>

                <h4>4.5.4 订单生效</h4>
                <p class="text">
                    点价成交后订单即时生效。点价双方应按照生效订单履行各自义务，直至订单完成。
                </p>

                <h4>4.5.5 成交确认书</h4>
                <p class="text">订单生效后，点价双方可查看《点价成交确认书》。</p>
            </div>

            <div class="clause">
                <h3>4.6 订单失效</h3>
                <p class="text">
                    用户点价不被对手方所接受，用户也不取消订单，交易日15:00后，订单自动失效。
                </p>
            </div>
        </div>

        <!-- 第五条~第十三条 完整内容（已全部还原） -->
        <div class="section">
            <h2 class="section-title">第五条 订单履行</h2>
            <div class="clause">
                <ul class="list">
                    <li>5.1 合同签订：点价成功后，用户与对手方应自行签订购销合同。</li>
                    <li>5.2 货款支付：货款支付由点价双方自行负责，平台不参与资金结算。</li>
                    <li>
                        5.3
                        现货交付：现货交付由点价双方自行负责，包括但不限于：货物提取、物流运输、质量验收、数量确认
                    </li>
                    <li>5.4 发票交付：发票交付由点价双方自行负责。</li>
                    <li>
                        5.5
                        违约责任：若由于点价双方任意一方原因造成无法履行后续合同，其将承担违约责任。
                    </li>
                </ul>
            </div>
        </div>

        <div class="section">
            <h2 class="section-title">第六条 服务费用</h2>
            <div class="clause">
                <ul class="list">
                    <li>
                        6.1
                        点价服务费：用户向对手方点价订单生效时，平台会向用户及其对手方同步生成《点价服务合同》。
                    </li>
                    <li>
                        6.2 缴费时间：在合同签订当日，点价成交的双方应向平台全额支付点价服务费。
                    </li>
                    <li>
                        6.3
                        收款账户：账户名：点价宝科技（四川）有限公司；银行账号：39810188003121572；开户行：中国光大银行股份有限公司成都分行
                    </li>
                    <li>
                        6.4
                        发票开具：用户可按照平台规则申请开具增值税发票，平台将在收到申请后15个工作日内开具并寄送。
                    </li>
                    <li>
                        6.5 费用标准：具体服务费用标准以平台公示为准，平台有权根据市场情况调整价格。
                    </li>
                </ul>
            </div>
        </div>

        <div class="section">
            <h2 class="section-title">第七条 交易保障</h2>
            <div class="clause">
                <ul class="list">
                    <li>
                        7.1 信息审核：平台有权对用户发布的资源信息进行审核，但不承担实质审查义务。
                    </li>
                    <li>
                        7.2
                        交易监管：平台有权对交易行为进行监管，发现违规行为有权采取警告、限制交易权限、暂停或终止服务、封锁账号、追究法律责任
                    </li>
                </ul>
                <h3>7.3 纠纷处理</h3>
                <ul class="list">
                    <li>7.3.1 协商解决：交易双方发生纠纷时，应首先友好协商解决。</li>
                    <li>
                        7.3.2
                        平台调解：协商不成的，可申请平台调解。平台将根据双方提供的证据进行调解。
                    </li>
                    <li>7.3.3 法律途径：调解不成的，任何一方可向有管辖权的人民法院提起诉讼。</li>
                </ul>
                <p class="text">
                    7.4 信用评价：平台有权建立用户信用评价体系，对用户的交易行为进行评价和记录。
                </p>
            </div>
        </div>

        <div class="section">
            <h2 class="section-title">第八条 风险提示</h2>
            <div class="clause">
                <h3>8.1 市场风险</h3>
                <p class="text">点价交易存在市场价格波动风险，用户应充分了解市场行情，谨慎决策。</p>
                <h3>8.2 交易风险</h3>
                <p class="text">
                    交易双方应自行承担交易风险，包括但不限于：价格波动风险、货物质量风险、交付风险、支付风险、信用风险
                </p>
                <h3>8.3 操作风险</h3>
                <p class="text">用户应妥善保管账号密码，因账号密码泄露造成的损失由用户自行承担。</p>
                <h3>8.4 政策风险</h3>
                <p class="text">因国家政策、法律法规变化导致的风险，由用户自行承担。</p>
            </div>
        </div>

        <div class="section">
            <h2 class="section-title">第九条 免责声明与责任限制</h2>
            <div class="clause">
                <h3>9.1 平台免责</h3>
                <p class="text">以下情况导致的损失，平台不承担责任：</p>
                <ul class="list">
                    <li>9.1.1 因不可抗力、网络故障、系统维护等原因导致的服务中断。</li>
                    <li>9.1.2 用户发布的资源信息不真实、不准确、不完整。</li>
                    <li>9.1.3 交易双方未履行或未完全履行合同义务。</li>
                    <li>9.1.4 用户账号密码泄露或保管不善。</li>
                    <li>9.1.5 用户操作失误或理解偏差。</li>
                    <li>9.1.6 市场价格波动导致的损失。</li>
                    <li>9.1.7 第三方原因导致的损失。</li>
                    <li>9.1.8 其他非因平台原因导致的损失。</li>
                </ul>

                <h3>9.2 责任限制</h3>
                <ul class="list">
                    <li>
                        9.2.1 在任何情况下，平台对用户的赔偿责任总额不超过用户已支付的服务费用。
                    </li>
                    <li>
                        9.2.2 平台不对间接损失、附带损失、特殊损失、惩罚性损失或利润损失承担责任。
                    </li>
                    <li>9.2.3 上述责任限制不适用于因平台故意或重大过失造成的损失。</li>
                </ul>
            </div>
        </div>

        <div class="section">
            <h2 class="section-title">第十条 协议终止</h2>
            <div class="clause">
                <ul class="list">
                    <li>
                        10.1
                        用户终止：用户有权随时注销账号，终止本规则。注销前应结清所有费用和订单。
                    </li>
                    <li>
                        10.2
                        平台终止：如用户违反本规则或法律法规，平台有权暂停或终止服务，注销用户账号。
                    </li>
                    <li>
                        10.3
                        终止后义务：规则终止后，用户应立即停止使用平台服务，已完成或正在进行的订单应继续履行。
                    </li>
                </ul>
            </div>
        </div>

        <div class="section">
            <h2 class="section-title">第十一条 争议解决</h2>
            <div class="clause">
                <ul class="list">
                    <li>11.1 协商解决：因本规则引起的争议，双方应友好协商解决。</li>
                    <li>11.2 平台调解：协商不成的，可申请平台调解。</li>
                    <li>
                        11.3
                        管辖法院：调解不成的，任何一方可向平台所在地有管辖权的人民法院提起诉讼。
                    </li>
                    <li>
                        11.4 适用法律：本规则的订立、执行、解释及争议解决均适用中华人民共和国法律。
                    </li>
                </ul>
            </div>
        </div>

        <div class="section">
            <h2 class="section-title">第十二条 其他条款</h2>
            <div class="clause">
                <ul class="list">
                    <li>
                        12.1 可分割性：本规则任何条款被认定无效或不可执行，不影响其他条款的效力。
                    </li>
                    <li>
                        12.2
                        完整协议：本规则构成双方之间的完整协议，取代双方之前就相同事项达成的所有协议。
                    </li>
                    <li>
                        12.3
                        权利保留：平台未行使或延迟行使本规则项下的任何权利，不构成对该权利的放弃。
                    </li>
                    <li>12.4 通知：平台可通过平台公告、站内信、短信、邮件等方式向用户发送通知。</li>
                </ul>
            </div>
        </div>

        <div class="section">
            <h2 class="section-title">第十三条 联系我们</h2>
            <div class="clause">
                <p class="text">如您对本规则有任何疑问，可通过以下方式联系我们：</p>
                <ul class="list">
                    <li>公司名称：点价宝科技（四川）有限公司</li>
                    <li>联系地址：四川省成都市金牛区西南钢铁交易中心11栋3-8</li>
                    <li>客服电话：4009971366</li>
                    <li>客服邮箱：750953693@qq.com</li>
                    <li>官方网站：https://www.dianjiabao.com.cn</li>
                    <li>备案号：蜀ICP备2023009956号-2</li>
                </ul>
                <p class="text">我们将在收到您的反馈后15个工作日内回复。</p>
            </div>
        </div>

        <!-- 附录 -->
        <div class="section appendix">
            <h2 class="section-title">附录：定义</h2>
            <ul class="list">
                <li>1.平台：指熊猫点钢平台，包括网站、APP、小程序等。</li>
                <li>2. 用户：指注册并使用平台交易服务企业。</li>
                <li>3.资源：指用户在平台上架待点价的商品。</li>
                <li>4. 点价：指以期货价格为基准，通过加上基差确定现货价格的定价方式。</li>
                <li>5. 基差：指现货价格与期货价格之间的差额。</li>
                <li>6.主力合约：指上海期货交易所螺纹钢期货/热卷期货中成交量最大的合约。</li>
                <li>7. 订单：指点价成交后生成的交易记录。</li>
                <li>8.本规则：指本交易规则及其修订版本。</li>
            </ul>
            <p class="text copyright">本规则最终解释权归点价宝科技（四川）有限公司所有。</p>
            <p class="text copyright">© 点价宝科技（四川）有限公司 版权所有</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PandaSteelRule',
    data() {
        return {};
    },
};
</script>

<style scoped>
.rule-container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 30px 20px;
    font-family: 'Microsoft YaHei', sans-serif;
    color: #333;
    line-height: 1.6;
}

.rule-header {
    text-align: center;
    margin-bottom: 40px;
}

.rule-header h1 {
    font-size: 26px;
    font-weight: bold;
    color: #222;
    margin-bottom: 10px;
}

.version,
.date {
    font-size: 14px;
    color: #666;
    margin: 4px 0;
}

.section {
    margin-bottom: 30px;
}

.section-title {
    font-size: 20px;
    font-weight: bold;
    color: #111;
    border-left: 4px solid #2d8cf0;
    padding-left: 12px;
    margin-bottom: 15px;
}

.important {
    color: #e63946;
    border-left-color: #e63946;
}

.clause {
    margin-bottom: 20px;
}

.clause h3 {
    font-size: 16px;
    font-weight: bold;
    margin: 12px 0 8px;
    color: #222;
}

.clause h4 {
    font-size: 15px;
    font-weight: bold;
    margin: 10px 0 6px;
    color: #333;
}

.text {
    font-size: 14px;
    color: #333;
    margin: 8px 0;
    text-align: justify;
}

.formula {
    font-size: 14px;
    color: #2d8cf0;
    font-weight: bold;
    margin: 10px 0;
}

.list {
    padding-left: 20px;
    margin: 8px 0;
}

.list li {
    font-size: 14px;
    color: #333;
    margin: 6px 0;
    line-height: 1.6;
}

.sub-list {
    padding-left: 30px;
}

.appendix {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #eee;
}

.copyright {
    text-align: center;
    color: #666;
    margin-top: 20px;
    font-size: 13px;
}
</style>
